import { render, staticRenderFns } from "./Comparative-assessment.vue?vue&type=template&id=04e8de2c"
import script from "./Comparative-assessment.vue?vue&type=script&lang=js"
export * from "./Comparative-assessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports